import BillRow from "./BillRow";

// component thông tin sản phẩm trong hóa đơn
const BillTable = ({ items }) => {
  let content = <p>No items.</p>;
  if (items && items.length > 0) {
    content = (
      <table className="cart_table" style={{ width: "100%" }}>
        <thead className="cart_table_head">
          <tr>
            <th className="cart_th">ID Sản phẩm</th>
            <th className="cart_th">Ảnh</th>
            <th className="cart_th">Tên</th>
            <th className="cart_th">Size</th>
            <th className="cart_th">Đơn giá</th>
            <th className="cart_th">SL</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <BillRow
              key={item.productId._id}
              item={item.productId}
              sizeInfo={item.sizeInfo}
              quantity={item.quantity}
            />
          ))}
        </tbody>
      </table>
    );
  }

  return content;
};

export default BillTable;
